export const getHeaders = (tipooferta,tipoprecio) => {
  const headers = [
    { field: "id", headerName: "ID", hidden: true },
    {
      field: "codigo",
      headerName: "Codigo",
      headerClassName: 'super-app-theme--header',
      headerAlign: 'center',
      minWidth: 70,
      cellClassName: 'centered-cell',
    },
    {
      field: "descripcion",
      headerName: "Descripcion",
      headerClassName: 'super-app-theme--header',
      headerAlign: 'center',
      minWidth: 200,
      cellClassName: 'centered-cell',
    },
    {
      field: "costo",
      headerName: "Costo",
      headerClassName: 'super-app-theme--header',
      headerAlign: 'center',
      minWidth: 120,
      cellClassName: 'centered-cell',
    },
    {
      field: "precio",
      headerName: Number(tipoprecio) === 1 ? "P. Minorista" : "P. Mayorista",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      minWidth: 120,
      cellClassName: "centered-cell",
    },
    {
      field: "descuento",
      headerName: "Descuento(%/$)",
      headerClassName: 'super-app-theme--header',
      headerAlign: 'center',
      minWidth: 120,
      cellClassName: 'centered-cell',
    },
    {
      field: "totaloferta",
      headerName: "Precio de Oferta",
      headerClassName: 'super-app-theme--header',
      headerAlign: 'center',
      minWidth: 120,
      cellClassName: 'centered-cell',
    },
    {
      field: "totalstock",
      headerName: "Stock Reservado",
      headerClassName: 'super-app-theme--header',
      headerAlign: 'center',
      minWidth: 120,
      cellClassName: 'centered-cell',
      hide: Number(tipooferta) === 0, // Oculta esta columna si tipooferta es 0
    },


  ];

  // Filtra columnas ocultas si tu DataGrid no soporta directamente el atributo `hide`
  return headers.filter((header) => !header.hide);
};
